        <!-- 轩辕英魂  技能-->
<template>
  <div class="TableContent-cont">
    <!--合体发起技能 start-->
    <div class="hero-skill-box current">
      <!--背景图 start-->
      <div class="skill-bg-box">
        <img
          src="https://tx3.res.netease.com/pc/qt/20151231153005/images/hero/skill_bg2_53bc235.jpg"
        />
      </div>
      <!--背景图 end-->
      <!--技能树 start-->
      <div class="skill-tree-box">
        <img
          src="https://tx3.res.netease.com/pc/qt/20151231153005/images/hero/htfq_17730ba.png"
        />
      </div>

      <!--技能树 end-->
      <div class="skill-tree-li">
        <ul class="passive_skill">
          <template v-for="(_, i) in 5" :key="`col-${i}`">
            <template v-for="(_, j) in 7" :key="`row-${j}`">
              <commonItem
                v-if="skill(cur_key, i, j)"
                :score="skill(cur_key, i, j).lv"
                :content="skill(cur_key, i, j).tips"
                :src="yhz_img2(skill(cur_key, i, j).icon, 2)"
              >
                <template v-slot:title>
                  <span style="color: #00c0ff">
                    {{skill(cur_key, i, j).name}}
                  </span>
                </template>
              </commonItem>
              <li class="HERO_display_none" v-else />
            </template>
          </template>
        </ul>
      </div>
    </div>
    <!--合体发起技能 end-->

    <ul class="hero-skill-name clear">
      <li @click="cur_key = 0" :class="{current:cur_key==0}">合体发起技能</li>
      <li @click="cur_key = 1" :class="{current:cur_key==1}">合体参与技能</li>
      <li @click="cur_key = 2" :class="{current:cur_key==2}" v-if="one.index == 2">召唤兽技能</li>
    </ul>
  </div>
</template>

<script setup>
import { defineProps, ref, computed, inject } from 'vue';

const { yhz_img2 } = inject('filters');
const props = defineProps({
  one: {
    type: Object,
    default: () => ({}),
  },
});

const cur_key = ref(0);

const skill = computed(() => {
  return (s_index, i, j) => props.one.skills[`(${s_index}, ${i}, ${j})`];
});
// 计算属性
// const new_role = computed(() => {
//     console.log('new_role', props.role_data)
//   return props.role_data?.new_role || {}
// })
</script>
